import { Injectable } from '@angular/core';
import { FeaturesDao } from '@models/partner-db.model';

@Injectable({
  providedIn: 'root'
})
export class FeatureService {
  private featuresList: { [key: string]: boolean } = {};
  private _isLoaded = false;

  loadSubscriptionFeatures(features: FeaturesDao[]): void {
    features?.length && features.forEach(feature => this.featuresList[feature.feature.name] = true);
    this._isLoaded = true;
  }

  hasFeature(feature: string): boolean {
    return this.featuresList[feature] || false;
  }

  // True once partner features have been loaded from the API. Used by
  // brand-leak gates (e.g. widget footer) to avoid rendering the default
  // "non-whitelabel" branch in the race window between widget-open and
  // partner-data response.
  get isLoaded(): boolean {
    return this._isLoaded;
  }
}
